export default {"src":"/login-app/[GIT_HASH]/_next/static/media/git_commit.258f9428.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};